import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M12.75 10a.75.75 0 0 0-1.5 0v2c0 .199.079.39.22.53l1 1a.75.75 0 1 0 1.06-1.06l-.78-.78z" />
    <path
      fillRule="evenodd"
      d="M10.647 1.25h2.666a2.75 2.75 0 0 1 2.742 2.213l.762 3.809A6.73 6.73 0 0 1 18.75 12a6.73 6.73 0 0 1-1.84 4.631l-.774 3.875a2.75 2.75 0 0 1-2.743 2.214h-2.706a2.75 2.75 0 0 1-2.742-2.213l-.755-3.771A6.73 6.73 0 0 1 5.25 12c0-1.834.731-3.497 1.918-4.713l.736-3.823a2.75 2.75 0 0 1 2.743-2.214m-2.22 14.596A5.235 5.235 0 0 1 6.75 12a5.23 5.23 0 0 1 1.664-3.836A5.23 5.23 0 0 1 12 6.75a5.23 5.23 0 0 1 3.54 1.372.8.8 0 0 0 .157.15 5.25 5.25 0 0 1-7.27 7.574m.554 2.193.434 2.174a1.25 1.25 0 0 0 1.25 1.007h2.749a1.25 1.25 0 0 0 1.25-1.006l.444-2.22A6.7 6.7 0 0 1 12 18.75a6.7 6.7 0 0 1-3.02-.711m5.604-14.282.441 2.208A6.7 6.7 0 0 0 12 5.25a6.7 6.7 0 0 0-3.052.728l.428-2.224a1.25 1.25 0 0 1 1.25-1.004h2.708a1.25 1.25 0 0 1 1.25 1.007"
      clipRule="evenodd"
    />
  </>
);

const Watch = Icon('watch', svgContents);

export default Watch;
